import { useClientTypeStore } from '@/store/clientTypes';
import { useClientsStore } from '@/store/clients';
import { useFiscalCatalogsStore } from '@/store/fiscalCatalogs';
import { useUsersStore } from '@/store/users';

export const clientsOptions = {
  getClientTypes: async (query = '') => {
    const store = useClientTypeStore();
    await store.fetchClientTypes({ 'filter[name]': query });
    return store.client_types;
  },
  searchClientsAndLeads: async (query = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads({ 'filter[name]': query });// 'filter[tag]':'Agencia' });
    return store.clients_leads;
  },
  searchPaymentMethods: async (query = '') => {
    const store = useFiscalCatalogsStore();
    await store.searchPaymentMethods({ 'filter[name]': query });
    return store.payment_methods;
  },
  searchFiscalRegiments: async (query = '') => {
    const store = useFiscalCatalogsStore();
    await store.searchFiscalRegiments({ 'filter[name]': query });
    return store.fiscal_regiments;
  },
  searchUsers: async (query = '') => {
    const store = useUsersStore();
    await store.searchUsers({ 'filter[name]': query });
    return store.users_result;
  },
  searchAgencies: async (query = '') => {
    const store = useClientsStore();
    await store.searchClients({ 'filter[name]': query, '&filter[tag]':'Agencia'});
    console.log(store.clients_result)
    return store.clients_result;
  },
};
